import {
  type CopilotHistoryChangedEventV1,
  copilotHistoryChangedEventV1Schema,
} from '@streamlain/copilot-realtime-contract';

export const COPILOT_HISTORY_CHANGED_BROWSER_EVENT =
  'streamlain:copilot-history-changed';
export const COPILOT_HISTORY_RECONNECTED_BROWSER_EVENT =
  'streamlain:copilot-history-reconnected';

/** Parses the /notification push; the wire contract is shared with the server. */
export function parseCopilotHistoryChangedEvent(
  payload: unknown
): CopilotHistoryChangedEventV1 | null {
  const parsed = copilotHistoryChangedEventV1Schema.safeParse(payload);
  return parsed.success ? parsed.data : null;
}

export function dispatchCopilotHistoryChangedEvent(payload: unknown): boolean {
  const event = parseCopilotHistoryChangedEvent(payload);
  if (!event) return false;
  window.dispatchEvent(
    new CustomEvent<CopilotHistoryChangedEventV1>(
      COPILOT_HISTORY_CHANGED_BROWSER_EVENT,
      { detail: event }
    )
  );
  return true;
}

/** Fired on every /notification (re)connect: pushes may have been missed. */
export function dispatchCopilotHistoryReconnectedEvent(): void {
  window.dispatchEvent(new Event(COPILOT_HISTORY_RECONNECTED_BROWSER_EVENT));
}

export function subscribeCopilotHistoryEvents(handlers: {
  onChanged: (event: CopilotHistoryChangedEventV1) => void;
  onReconnected: () => void;
}): () => void {
  const onChanged = (event: Event) => {
    const parsed = parseCopilotHistoryChangedEvent(
      (event as CustomEvent<unknown>).detail
    );
    if (parsed) handlers.onChanged(parsed);
  };
  const onReconnected = () => handlers.onReconnected();
  window.addEventListener(COPILOT_HISTORY_CHANGED_BROWSER_EVENT, onChanged);
  window.addEventListener(
    COPILOT_HISTORY_RECONNECTED_BROWSER_EVENT,
    onReconnected
  );
  return () => {
    window.removeEventListener(
      COPILOT_HISTORY_CHANGED_BROWSER_EVENT,
      onChanged
    );
    window.removeEventListener(
      COPILOT_HISTORY_RECONNECTED_BROWSER_EVENT,
      onReconnected
    );
  };
}
